export default {
    bindings: {
        activities: '<',
        categories: '<'
    },
    controller: 'activityListController',
    template: require('../views/activity.list.html')
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/activity/components/activity.list.component.js